import {
  createListItem,
  ItemListingParams,
} from '../structuredMappers/itemListing';
import { OrganizationMapperResult } from '../structuredMappers/organization';
import { generateUrl, nonNullable } from '../utils';

export const rawToItemListing = (
  {
    item: [{ pageBlock, items }],
  }: {
    item: [
      {
        pageBlock: {
          heading: {
            headline: string;
          };
        };
        items: {
          items: Partial<{
            fullPath: string;
            fields: {
              fullPath: string;
            };
            ctaBlocks: {
              link: {
                link:
                  | {
                      fields: {
                        fullPath: string;
                      };
                    }[]
                  | null;
              };
            }[];
            heading: {
              link: {
                link: {
                  fields: {
                    fullPath: string;
                  };
                }[];
              }[];
            };
          }>[];
        }[];
      }
    ];
  },
  organization: OrganizationMapperResult
): ItemListingParams | null => {
  const result = items[0].items
    .map((item) => {
      if (item.fullPath) {
        return generateUrl(item.fullPath, organization.url);
      }

      if (item.fields?.fullPath) {
        return generateUrl(item.fields.fullPath, organization.url);
      }

      if (item.ctaBlocks?.[0]?.link?.link?.[0]?.fields.fullPath) {
        return generateUrl(
          item.ctaBlocks[0].link.link[0].fields.fullPath,
          organization.url
        );
      }

      if (item.heading?.link?.[0]?.link?.[0]?.fields.fullPath) {
        return generateUrl(
          item.heading.link[0].link[0].fields.fullPath,
          organization.url
        );
      }

      return null;
    })
    .filter(nonNullable)
    .map((url, index) => createListItem({ item: url, position: index + 1 }));

  if (result.length === 0) {
    return null;
  }

  return {
    name: pageBlock.heading.headline || '',
    items: result,
  };
};
